/** Access file for agent accounts (NEX-1980); it is built in the browser only and never sent to the server. */
export const AGENT_ENV_FILE_NAME = 'zugaenge.env';

const ENV_VAR_PREFIX = 'TESTOFFICE_PAT_';

export interface AgentEnvEntry {
  kuerzel: string;
  token: string;
}

/** Kuerzel only contain `a-z`, `0-9` and `-` (backend `TenantUser.isValidKuerzel`), so this yields a valid name. */
export function envVarName(kuerzel: string): string {
  return ENV_VAR_PREFIX + kuerzel.toUpperCase().replaceAll('-', '_');
}

export function buildAgentEnvFile(entries: readonly AgentEnvEntry[]): string {
  return entries.map((entry) => `${envVarName(entry.kuerzel)}=${entry.token}\n`).join('');
}
